import React from 'react';

export default function EvenementsForm({ formData, handleChange }) {
    
  return (
    <div className="subform" translate="no">
      <h2 className="text-center font-bold text-l border-2 border-blue-500 rounded-md p-4 mb-6">Évènements</h2>
            <label>Nom organisateur :</label>
            <input type="text" className="form-control mb-2" name="organisateurEvenement" value={formData.organisateurEvenement} onChange={handleChange}/>
            <label>Lieu évènement :</label>
            <input type="text" className="form-control" name="lieuEvenement" value={formData.lieuEvenement} onChange={handleChange}/>
            <label>Date :</label>
            <input type="date" className="form-control mb-2" name="dateEv" value={formData.dateEv} onChange={handleChange}/>
      
            <label>Titre de l'évènement :</label>
            <input type="text" className="form-control mb-2" name="titreEvenement" value={formData.titreEvenement} onChange={handleChange}/>
            <label>Nombre de participants CEA :</label>
            <input type="text" className="form-control" name="EvParticipantCea" value={formData.EvParticipantCea} onChange={handleChange}/> 
            <div className="mb-3">
              <label>Domaine / Secteur de l'évènement</label><br />
              <input type="radio" name="domaineEvenement" value="carbone" onChange={handleChange} />  Carbone<br />
              <input type="radio" name="domaineEvenement" value="agriculture" onChange={handleChange} />  Agriculture<br />
              <input type="radio" name="domaineEvenement" value="environnement" onChange={handleChange} />  Environnement<br />
              <input type="radio" name="domaineEvenement" value="autres" onChange={handleChange} />  Autre (préciser) <br />

              {formData.domaineEvenement === "autres" && (
        <div className="mt-3">
          <label>Domaine de l'évènement : </label>
          <input type="text" className="form-control" name="autreEvenement" value={formData.autreEvenement} onChange={handleChange}/>
      
        </div>
      )}
            
            </div>
    </div>
  );
}